import Vue from 'vue'
const extractQueryParameter = require('~/utils/queryParams')

Vue.filter('extractQueryParameter', extractQueryParameter)
Vue.prototype.$extractQueryParameter = extractQueryParameter
